module.exports = __webpack_public_path__ + "static/media/pic3.420a81dd.jpg";